module.exports = __webpack_public_path__ + "media/assets/images/votorantim-cimentos@3x-21f36ab4e3999952b3915c566ebb218a.png";